export default "__VITE_ASSET__DvKfJTm$__"